import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "form-check flex flex-row gap-[8px]" }
const _hoisted_3 = ["name"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["BaseInput"], {
    class: "checkbox-input",
    errorMessage: $setup.errorMessage,
    meta: $setup.meta,
    name: $props.name
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("input", {
            id: "`check_${name}`",
            class: "form-check-input focus:!text-gold focus:!ring-gold appearance-none mt-[4px] h-4 w-4 border border-purple-500 rounded-sm bg-white checked:!bg-purple-500 checked:border-purple-500 hover:checked:text-purple-500 focus:outline-none transition duration-200 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer",
            type: "checkbox",
            onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleChange($props.value))),
            name: $props.name
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_3),
          _createElementVNode("label", {
            class: "form-check-label inline-block text-gray-900 dark:text-gray-300",
            for: `check_${$props.name}`
          }, [
            ($setup.hasSlot('default'))
              ? _renderSlot(_ctx.$slots, "default", { key: 0 })
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  innerHTML: $props.label
                }, null, 8 /* PROPS */, _hoisted_5))
          ], 8 /* PROPS */, _hoisted_4)
        ])
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["errorMessage", "meta", "name"]))
}